export default "__VITE_ASSET__900770bc__"